export const useReferenceContainer = () => {
  const referenceContainer = ref<HTMLDivElement | null>(null);
  const { left, x, width, height } = useElementBounding(referenceContainer);

  // Convert shallow refs to regular refs for consistent API
  const leftRef = ref(left.value);
  const xRef = ref(x.value);
  const widthRef = ref(width.value);
  const heightRef = ref(height.value);

  // Watch for changes and update our refs
  watch(left, (newValue) => leftRef.value = newValue);
  watch(x, (newValue) => xRef.value = newValue);
  watch(width, (newValue) => widthRef.value = newValue);
  watch(height, (newValue) => heightRef.value = newValue);

  return {
    referenceContainer,
    left: leftRef,
    x: xRef,
    width: widthRef,
    height: heightRef,
  };
}; 